module.exports = __webpack_public_path__ + "img/apple-icon-60x60.f3c3488f.png";